<template>
  <div>
    <div class="handleBox">
      <div>
        <div class="head-kv-banner">
          <el-carousel :interval="5000" arrow="always" height="830px">
            <el-carousel-item v-for="(item,index) in recommend" :key="index">
              <img alt="" :src="baseUrl()+item.img">
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
    <el-container class="topContainer" style="min-height: calc(100vh - 306px);">
      <el-main style="padding: 0px; width: 100%;color: black;">
        <transition name="run" :duration="2000">
          <div class="content" v-show="showContent">
            <el-container>
              <el-main class="page-component__scroll">
                <div class="myHome">
                  <header>
                    <div class="header">
                      <div class="noBody live-list-wrap">
                        <div class="live-header"></div>
                        <div class="live-content">
                          <div style="display: flex;">
                            <div class="left">
                              <div style="height: 100%;">
                                <h2 class="title">{{video.name}}</h2>
                                <img :src="baseUrl() + video.picture" alt="" class="coverImage">
                                <img src="@/img/play_icon.png" width="66px" height="66px" class="icon" alt="" @click="toVideo(video.id)">
                                <div class="title-mask"></div>
                              </div>
                            </div>
                            <ul class="right">
                              <li v-for="(item, index) in video_list.slice(0, 4)" :key="index" @click="selectVideo(item)">
                                <img :src="baseUrl() + item.picture" height="98px" class="coverImg" style="width: 176px; flex-shrink: 0;" alt="">
                                <div class="info-box">
                                  <span>{{item.name}}</span>
                                  <i class="playing_icon"></i>
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </header>
                </div>
              </el-main>
            </el-container>
          </div>
        </transition>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import axios from 'axios'
import gsap from 'gsap'
import {baseUrl} from "@/components";
export default {
  name: "Banner",
  data() {
    return {
      video_list: [],
      video: {},
      showContent: false,
      recommend:{},
    };
  },
  created() {
    this.getVideos()
    this.getRecommend()
  },
  mounted() {
    gsap.from('.noBody', {
      opacity: 0,
      y: 100,
      ease: "power3",
      duration: 3
    })
  },
  methods: {
    baseUrl,
    getVideos() {
      axios.get('/web/video/list?pageSize=9&pageNum=1').then((res) => {
        if (res.data.rows && res.data.rows.length > 0) {
          this.video_list = res.data.rows;
          this.video = res.data.rows[0];
          this.showContent = true;
        }
      })
    },
    getRecommend() {
      axios.get('/web/recommend/list').then((res) => {
        if (res.data.rows && res.data.rows.length > 0) {
          this.recommend = res.data.rows;
          console.log(this.recommend);
        }
      })
    },
    selectVideo(obj) {
      if (obj) {
        this.video = obj;
      }
    },
    toVideo(url) {
      // location.replace('https://www.baidu.com')
      // const w = window.open();
      // w.location.href = 'https://admin.nxhzy.cn/prod-api' + url;
      let routeData = this.$router.resolve({
             path: '/site/spDetail',
            query: {
                    id:url,
                    }
           })
           window.open(routeData.href, '_blank')

    }
  }
}
</script>
<style scoped>
@media screen and (min-width: 1300px) {
  .handleBox {
    min-height: 6.3125rem !important
  }
}

@media screen and (max-width: 1299px) {
  .handleBox {
    min-height: 9.375rem !important
  }
}

#app .head-kv-banner {
  position: absolute;
  top: 0;
  z-index: 1;
  cursor: default;
  width: 100%;
  height: 51.875rem
}

#app .head-kv-banner .el-carousel__indicators--horizontal {
  position: absolute;
  bottom: 15.625rem !important;
  left: inherit;
  right: 22.5rem;
  transform: inherit
}

@media screen and (max-width: 1440px) {
  #app .head-kv-banner .el-carousel__indicators--horizontal {
    right: 7.3125rem
  }
}

#app .head-kv-banner:after {
  content: "";
  position: absolute;
  width: 100%;
  height: 9.375rem;
  bottom: 0;
  left: 0;
  z-index: 9;
  background-image: linear-gradient(transparent, #fff)
}

#app .head-kv-banner img {
  width: 100%;
  height: 100%;
  object-fit: cover
}

#app .head-kv-banner :deep() .el-carousel__container .is-active:after {
  content: "";
  display: inline-block;
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 11.3125rem;
  background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff)
}

.el-carousel__item h3 {
  display: flex;
  color: #475669;
  opacity: 0.75;
  line-height: 300px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}

.containerComponent .el-container {
  margin: 0 auto;
}

.containerComponent .content {
  height: 100%
}

.containerComponent .content .title {
  font-size: 1.875rem;
  font-weight: 400;
  color: #0a1822;
}

.containerComponent .breadcrumb {
  width: 75rem;
  line-height: 1.375rem;
  margin: 1.5rem auto 1.25rem;
  font-size: .875rem;
  color: #343434
}

.containerComponent .breadcrumb a {
  font-size: .875rem;
  color: #343434;
  text-decoration: none
}

.myHome header .head-kv-banner img {
  width: 100%;
  height: 100%
}

.myHome header .header {
  position: relative;
  left: calc(50% - 37.5rem);
  z-index: 1;
  margin-top: 31rem;
  width: 75rem;
  height: 28.75rem
}

.myHome header .header-title {
  height: 3.5rem
}

.myHome header .header-title .icon {
  position: absolute;
  z-index: 1;
  top: -2.5rem;
  left: -2.0625rem
}

.myHome header .header-title .title-content {
  position: relative;
  width: 32.5rem;
  height: 100%;
  padding: 0 0 0 5.875rem
}

.myHome header .header-title .title-content .title-mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  backdrop-filter: blur(.125rem)
}

.myHome header .header-title .title-content .content {
  white-space: nowrap;
  position: absolute;
  font-size: 1.125rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #fff;
  line-height: 1.5625rem;
  min-height: 3.75rem;
  display: flex;
  align-items: center
}

.myHome header .header-title .title-content .content .countNum {
  font-size: 2.25rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #fff;
  line-height: 3.125rem;
  margin: 0 .625rem .4375rem
}

.myHome header .header .live-content {
  display: flex;
  justify-content: center;
  padding: .75rem .875rem 0 .875rem;
  background: #fff;
  box-shadow: 0 .375rem 1.25rem 0 rgba(34, 47, 71, .12)
}

.myHome header .header .live-content .left {
  position: relative;
  width: 47.489375rem;
  height: 27.1875rem
}

.myHome header .header .live-content .left .title-mask {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 4rem;
  background: rgba(0, 0, 0, .2);
  backdrop-filter: blur(.5rem)
}

.myHome header .header .live-content .left .title {
  position: absolute;
  bottom: 1.25rem;
  left: 1.5rem;
  right: 1.5rem;
  font-size: 1rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #fff;
  line-height: 1.5rem;
  z-index: 5;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  word-break: break-all
}

.myHome header .header .live-content .left img.coverImage {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%
}

.myHome header .header .live-content .left img.icon {
  position: absolute;
  bottom: 1.9375rem;
  right: 1.9375rem;
  width: 4.125rem;
  height: 4.125rem;
  z-index: 5;
  cursor: pointer
}

.myHome header .header .live-content .right {
  display: flex;
  flex-direction: column;
  flex: 1;
  margin-left: .75rem
}

.myHome header .header .live-content .right li {
  display: flex;
  font-size: 1rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333;
  line-height: 1.5rem;
  margin-bottom: .75rem;
  border: .0625rem solid transparent
}

.myHome header .header .live-content .right li .playing_icon {
  height: 1.25rem
}

.myHome header .header .live-content .right li .info-box {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  margin-left: 1rem;
  width: 12.875rem
}

.myHome header .header .live-content .right li .info-box span {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  word-break: break-all
}

.myHome header .header .live-content .right li .info-box img {
  width: 1.25rem;
  height: 1.25rem
}

.myHome header .header .live-content .right li:hover {
  color: #236dd4;
  background: linear-gradient(135deg, #f7faff, #f2f7ff);
  box-shadow: 0 .25rem .625rem 0 rgba(26, 115, 238, .24);
  border: .0625rem solid #1a73ee;
  cursor: pointer
}

.myHome header .header .live-content .right li:hover .playing_icon {
  display: inline-block;
  width: 1.25rem;
  height: 1.25rem;
}

.myHome header .header .live-content .right li:hover .info-box span {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  word-break: break-all
}

.myHome header .header .live_fade-enter,
.myHome header .header .live_fade-leave-to {
  opacity: 0;
  transform: translateY(100%)
}

.myHome header .header .live_fade-enter-active,
.myHome header .header .live_fade-leave-active {
  transition: all 2s ease
}

.myHome header .header .live_fade-enter-to,
.myHome header .header .live_fade-leave {
  transform: translateY(0);
  opacity: 1
}

.more {
  cursor: pointer !important
}

.title {
  display: flex
}

.title h2,
.title p {
  font-size: 2.75rem;
  line-height: 3.875rem;
  font-family: PingFangSC-Light, PingFang SC;
  font-weight: 300;
  color: #333
}

.title p {
  font-size: 1.5rem;
  line-height: 2.0625rem;
  margin-left: 1.25rem;
  align-self: flex-end
}
</style>
